import classNames from 'classnames';
import { ReactElement, useId, useState } from 'react';
import { DownOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';

import styles from './MenuGroupItem.module.scss';

interface IProps {
  collapsed: boolean;
  visibleDefault?: boolean;
  groupItems: ReactElement;
  text: string;
}

export const MenuGroupItem = ({ visibleDefault, collapsed, groupItems, text }: IProps) => {
  const [groupItemsVisibleBelow, setGroupItemsVisibleBelow] = useState(visibleDefault);
  const groupItemsId = useId();

  return (
    <div>
      <Tooltip title={collapsed ? text : null} placement="right">
        <button
          type="button"
          aria-label={text}
          aria-expanded={groupItemsVisibleBelow}
          aria-controls={groupItemsId}
          onClick={() => setGroupItemsVisibleBelow((visible) => !visible)}
          className={classNames(styles.submenuTitle, { [styles.collapsed]: collapsed })}
        >
          <span className={styles.categoryText}>{text}</span>
          <span
            className={classNames(styles.rotatable, {
              [styles.rotate180]: groupItemsVisibleBelow,
              [styles.arrowHidden]: collapsed,
            })}
          >
            <DownOutlined />
          </span>
        </button>
      </Tooltip>
      <div id={groupItemsId} hidden={!groupItemsVisibleBelow}>
        {groupItems}
      </div>
    </div>
  );
};
